import React, { useState } from 'react';
import DisplayTradePlanSetup from '../DisplayTradePlanSetup';
import style from './DisplayTradePlanWatchlists.module.css';
import IncrementButton from '../../../../atomic/buttons/incrementButton/IncrementButton';
import { colors } from '../../../../../colorVars';
import { Heading4 } from '../../../../atomic/text/Text';

var runningNumber = 0;
export default function DisplayTradePlanWatchLists({ userPreferences }) {
  const [watchlist, setWatchlist] = useState({});

  const deleteIndex = (index) => {
    delete watchlist[index];
    const deepCopy = {};
    Object.keys(watchlist).map((key) => (deepCopy[key] = watchlist[key]));
    setWatchlist(deepCopy);
  };

  return (
    <div className={style.outerContainer}>
      {/* <Heading4 color={colors.lightGrey}>Trade Plan Watchlists</Heading4> */}
      <div className={style.watchlistContainer}>
        {Object.keys(watchlist).map((key) => (
          <div key={key} className={style.border}>
            <DisplayTradePlanSetup
              userPreferences={userPreferences}
              deleteIndex={deleteIndex}
              index={key}
              key={key}
            />
          </div>
        ))}
        {/* <IncrementButton
          margin="5px"
          paddingPercent={20}
          width={20}
          buttonWidth="30px"
          borderRadius="5px"
          color={colors.white}
          backgroundColor={colors.green}
          stroke={3}
          handleClick={() => {
            let key = runningNumber++;
            watchlist[key] = true;
            const deepCopy = {};
            Object.keys(watchlist).map(
              (key) => (deepCopy[key] = watchlist[key])
            );
            setWatchlist(deepCopy);
          }}
        /> */}
      </div>
    </div>
  );
}
